import React, {Component} from "react" ;
import "../../util/explorer_support";

class Body extends Component {
	render() {
		return (
			<tbody>
			{
				this.props.items.length === 0 ?
					<tr>
						<td colSpan={this.props.columns.length}>
							{this.props.emptyMessage}
						</td>
					</tr> :
					this.props.items.map((item, i) =>
						// <tr key={i} style={this.props.getTrStyles !== undefined ? this.props.getTrStyles(item) : {}} className={this.props.getTrClass !== undefined ? this.props.getTrClass(item) : {}}>
						<tr key={i} style={item.read === false ? {backgroundColor:"#FFE4E1", color:"black"} : {backgroundColor:"#F0FFFF", color:"black"}} className={this.props.getTrClass !== undefined ? this.props.getTrClass(item) : {}}>
							{
								this.props.columns.map((column, j) =>
								typeof column.accessor === "string" ? (column.Cell === undefined ?
										<td key={j} style={column.getTdStyles && column.getTdStyles(item)} data-label={column.Header}>{item[column.accessor]}</td> :
										<td key={j} style={column.getTdStyles && column.getTdStyles(item)} data-label="">{column.Cell(item, i)}</td>
								) : (<td key={j} style={column.getTdStyles && column.getTdStyles(item)} data-label="">
										{
											(column.Cell === undefined ?
													column.accessor.map((data, k) =>
														<p key={k}>{item[data.accessor] + (k + 1 < column.accessor.length ? "-" : "")}</p>
													) :
													column.Cell("column: ",item, i)
											)
										}

									</td>
								))
							}
						</tr>
					)
			}
			</tbody>
		);
	}
}

export default Body;


// WEBPACK FOOTER //
// ./src/components/Table/Body.js